<template>
  <div>
    <b-row class="mb-3">
      <b-col cols="12">
        <PageHeader :title="$cte('income.title')" />
      </b-col>
    </b-row>
    <b-tabs @input="onTabInput" v-model="activeTab" style="width: 100% !important;" lazy>
      <b-tab
        lazy
        :title="$cte('invoice.summary')"
        v-if="isEvTaxationResult"
        class=""
        style=""
        id="g4"
      >
        <IncomesSummary :company-id="getActiveCompany.id" :is-inbound="false" class="" />
      </b-tab>
      <b-tab
        lazy
        :title="$cte('common.uploads')"
        class=""
        style=""
      >
        <income-list />
      </b-tab>
      <b-tab title="NAV" lazy>
        <NavInvoice invoice-direction="OUTBOUND" />
      </b-tab>
      <b-tab title="Számlázz.hu" lazy v-if="hasSzamlazzhuKey">
        <AppInvoice direction="OUTBOUND" source="SZAMLAZZ_HU" :company-id="getActiveCompany.id" />
      </b-tab>
      <b-tab title="Billingo" lazy v-if="hasBillingoKey">
        <AppInvoice direction="OUTBOUND" source="BILLINGO" :company-id="getActiveCompany.id" />
      </b-tab>
      <b-tab title="Nyugták" lazy>
        <receipts :company-id="getActiveCompany.id" />
      </b-tab>
      <b-tab title="Pénztárgépek">
        <Cashregisters :company-id="getActiveCompany.id" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Api from "api-client";
import { mapGetters } from "vuex";
import PageHeader from "@/components/PageHeader";
import NavInvoice from "../../../components/NavInvoice";
import { isEvTaxation } from "@/utils/CommonLogic";
import Util from "@/utils/Util";
import IncomesSummary from "@/views/app/incomes/IncomesSummary.vue";
import Receipts from "@/views/app/incomes/Receipts.vue";
import AppInvoice from "@/views/app/invoicing/AppInvoice.vue";
import Cashregisters from "@/views/app/incomes/Cashregisters.vue";
import IncomeList from "@/views/app/incomes/IncomeList.vue";

export default {
  name: "Incomes",
  components: {
    IncomeList,
    Cashregisters,
    AppInvoice,
    Receipts,
    IncomesSummary,
    PageHeader,
    NavInvoice
  },
  data() {
    return {
      activeTab: 0,
      isEvTaxation: isEvTaxation,
      isEvTaxationResult: false,
      visitedTabs: [],
      page: 1,
      offset: 3,
      hasSzamlazzhuKey: false,
      hasBillingoKey: false,
    };
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  methods: {
    fetchEvTaxationStatus() {
      if (this.getActiveCompany) {
        this.isEvTaxation(this.getActiveCompany)
          .then(result => {
            this.isEvTaxationResult = result;
          })
          .catch(error => {
            console.error("Error fetching taxation status:", error);
            this.isEvTaxationResult = false;
          });
      }
    },
    onTabInput(value) {
      if (!this.visitedTabs.includes(value)) {
        this.visitedTabs.push(value);
      }
    },

    newInvoice() {
      this.$router.push("/app/incomes/upload");
    },
    checkApiKeys() {
      if (this.getActiveCompany && this.getActiveCompany.id) {
        Api.getSzamlazzhuKey(this.getActiveCompany.id).then((resp) => {
          if (resp.data && resp.data.key) {
            this.hasSzamlazzhuKey = true;
          }
        }).catch(() => {
          this.hasSzamlazzhuKey = false;
        });

        Api.getBillingoToken(this.getActiveCompany.id).then(resp => {
          if (resp.data && resp.data.token) {
            this.hasBillingoKey = true;
          }
        }).catch(() => {
          this.hasBillingoKey = false;
        });
      }
    },
  },
  watch: {
    activeTab() {
      Util.storeGlobalData("incomes-active-tab", this.activeTab);
    },
    getActiveCompany: {
      handler() {
        this.checkApiKeys();
        this.fetchEvTaxationStatus();
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (window.innerWidth > 768) {
      this.myIncomesOptions.itemPerPage = 10;
    } else {
      this.myIncomesOptions.itemPerPage = 3;
    }
    this.checkApiKeys();

    let previousActiveTab = Util.getGlobalData("incomes-active-tab");
    if (previousActiveTab) {
      this.activeTab = previousActiveTab;
    }
  },
};
</script>

<style scoped>
* >>> .custom-dropdown > button:hover {
  color: #5bb65d !important;
  background-color: transparent;
}

* >>> .custom-dropdown > button {
  background-color: transparent;
  color: #80808f !important;
  border: none;
  position: absolute;
  bottom: -17px;
  left: -17px;
}

.custom-dropdown {
  width: 46px;
}
</style>
